import { useRef } from 'react';
import Cookies from 'js-cookie';

import { clearAllCookies } from 'src/utils/helper';

/**
 * Hook to poll for add card result using cookies.
 *
 * @param {Object} options
 * @param {Function} [options.onSuccess] - Called when card add is successful
 * @param {Function} [options.onError] - Called when card add fails
 * @param {Function} [options.onComplete] - Called when polling ends
 */
export const useAddCardCookiePoller = ({ onSuccess, onError, onComplete } = {}) => {
  const intervalRef = useRef(null);
  const lastMessageRef = useRef(null);

  const startPolling = () => {
    if (intervalRef.current) {
      // console.log('[Poller] Polling already running.');
      return;
    }

    console.log('[Poller] Starting polling...');
    intervalRef.current = setInterval(() => {
      const addCardStatus = Cookies.get('addCardStatus');
      const addCardMessage = Cookies.get('addCardMessage');

      // console.log('[Poller] Checking cookies:', {
      //   addCardStatus,
      //   addCardMessage,
      //   fullCookie: document.cookie,
      // });

      if (addCardStatus === 'false' && addCardMessage) {
        const isSuccess = addCardMessage.toLowerCase().includes('success');
        
        console.log('[Poller] Card add detected. Status:', isSuccess ? 'SUCCESS' : 'ERROR');
        // console.log('[Poller] Message:', addCardMessage);
        lastMessageRef.current = addCardMessage; // Track last message

        // // Reset cookies
        Cookies.remove('addCardStatus', {
          path: '/',
          domain: '.shahen-sa.com',
        });

        Cookies.remove('addCardMessage', {
          path: '/',
          domain: '.shahen-sa.com',
        });

        if (isSuccess) {
          onSuccess?.();
        } else {
          onError?.();
        }

        onComplete?.();
      }
    }, 500);
  };

  const stopPolling = () => {
    if (intervalRef.current) {
      console.log('[Poller] Manually stopping polling.');
      clearInterval(intervalRef.current);
      intervalRef.current = null;
      clearAllCookies()
    }
  };

  return { startPolling, stopPolling };
};
